export default __webpack_public_path__ + "d67f62be8dc8003aa32a863afa4cfa62.png";